import { render } from "./DeviationDisplayComponent.vue?vue&type=template&id=9ff64f62"
import script from "./DeviationDisplayComponent.vue?vue&type=script&lang=js"
export * from "./DeviationDisplayComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__